var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"d-flex \n  justify-center \n  black \n  font-weight-bold \n  grey--text\n  text--lighten-2",attrs:{"id":"footer"}},[_vm._v(" Copyright © 2020 ")])}
var staticRenderFns = []

export { render, staticRenderFns }